import script from "./WebsiteNav.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteNav.vue?vue&type=script&setup=true&lang=js"

import "./WebsiteNav.vue?vue&type=style&index=0&id=2b63523f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b63523f"]])

export default __exports__